













































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

declare let apigClientFactory: any;

export default Vue.extend({
  data: () => {
    return {
      form: {
          error: false,
          submitting: false,
          phone: '',
      },
      form2: {
        error: false,
        submitting: false,
        noPolis: '',
        completed: false,
        valid: false,
        loading: false
      },
      submissionId: "",
      number: 'number',
      isLoading: false,
      isCompleted: false,
      isValid: true,
      subscribers: [],
      questionaireIdentifier: "",
      campaignOption: [
        {text: "WCO", value: {d: "WCO", isEForm: 0}},
        {text: "MPD", value: {d: "MPD", isEForm: 1}},
      ],
      campaign: {d: "WCO", isEForm: 0},
      fileInput: null as any,
      isLoadingNotif: false,
    };
  },
  methods: {
    async onSubmitNotification(){
      this.isLoadingNotif = true
      console.log("CAMPAIGN: ", this.campaign)
      console.log("URL: ", process.env.VUE_APP_API_URL)
      const form = new FormData();
      form.append('file', this.fileInput);

      try{
        let response = await axios.post(`${process.env.VUE_APP_API_URL}/notification/send?appType=${this.campaign.d}&isEForm=${this.campaign.isEForm}`, form)
        console.log(response.data)
        this.$swal({
          icon: 'success',
          text: 'Berhasil mengirimkan notifikasi!',
          timer: 3000,
          timerProgressBar: true,
        });
      }catch(e){
        console.log(e)
        this.$swal({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Gagal mengirimkan notifikasi!',
          timer: 3000,
          timerProgressBar: true,
        });
      }
      this.isLoadingNotif = false
    },
    onSubmit() {
      // console.log('touch down');

      this.form.submitting = true;

      this.clearStatus();

      if (this.invalidPhone) {
          this.form.error = true;
          return;
      }

      this.form.error = false;
      this.form.submitting = false;

      this.getApiSmsSend(this.form.phone);
    },
    onSubmitNoPolis() {
      console.log('touch down');
      this.form2.submitting = true

      //clearStatus
      
      this.form2.error = false;
      this.form2.completed = false;

      console.log(this.form2)
      if (this.invalidNoPolis) {
          this.form2.error = true;
          return;
      }

      this.form2.error = false;
      this.form2.submitting = false;
      

      this.submissionOptionalSend(this.form2.noPolis);
    },
    submissionOptionalSend(noPolis: any, token: any = undefined) {
      const authorization = token!=undefined?token:`Bearer ${this.$store.getters.getToken()}`;
      const params = {
        // This is where any header, path, or querystring request params go.
        authorization: authorization
      };
      const body = {
        // This is where you define the body of the request
        noPolis: noPolis,
      };
      const additionalParams = {
      };
      const apigClient = apigClientFactory.newClient();
      this.form2.loading = true;

      apigClient.apiV1SubmissionOptionalPost(params, body, additionalParams)
        .then((result: any) => {
            this.form2.loading = false;
          console.log('result', result);

          this.form2.noPolis = '';
          this.form2.completed = true;
          this.form2.valid = true;
          this.submissionId = result.data.data.submissionId
          // this.$router.push('/questionnaire');
        }, 
        (error: any) => {
          if(error.status == 406){
            this.form2.loading = false;
            this.form2.completed = true;
            this.form2.valid = false;
          }else{
            this.getRefreshTokenNoPolis(error)
          }
        });
    },
    getApiSmsSend(phone: any, token: any = undefined){
      const authorization = token!=undefined?token:`Bearer ${this.$store.getters.getToken()}`;
      const params = {
        // This is where any header, path, or querystring request params go.
        authorization: authorization
      };
      const body = {
        // This is where you define the body of the request
        destinationNumber: phone,
      };
      const additionalParams = {
      };

      const apigClient = apigClientFactory.newClient();
      this.isLoading = true;
      apigClient.apiV1SmsSendPost(params, body, additionalParams)
        .then((result: any) => {
          this.isLoading = false;
          console.log('result', result);

          this.form.phone = '';
          this.isCompleted = true;
          this.isValid = true;
          // this.$router.push('/questionnaire');
        }, 
        (error: any) => {
          if(error.status == 406){
            this.isLoading = false;
            this.isCompleted = true;
            this.isValid = false;
          }else{
            this.getRefreshToken(error)
          }
        });
    },
    clearStatus() {

        this.form.error = false;
        this.isCompleted = false;
    },
    onAccessTokenFetched(access_token: any) {
      this.subscribers = this.subscribers.filter((callback:any) => callback(access_token))
    },
    addSubscriber(callback: any) {
      let sub : any = this.subscribers
      sub.push(callback);
      this.subscribers = sub;
    },
    _expiredSession() {
      console.log('token expired!')
      this.$store.commit('SET_LoggedIn', false);
      this.$store.commit('SET_Token', "");
      this.$store.commit('SET_RefreshToken', "");
      this.$store.commit('SET_IsFatchToken', false)
      this.$router.push('/');
    },
    getRefreshToken(error: any){
      const { config } = error
      const originalRequest = config;

      console.log("error isLoggedIn", this.$store.getters.getLoggedIn())
      if(this.$store.getters.getLoggedIn() === true) {
        console.log("error status", error.status)
        if(error.status == 401) {
          console.log('intercept errors 401', this.$store.getters.getRefreshToken())
          if (!this.$store.getters.getRefreshToken()) {
            this._expiredSession();
          } else {
            console.log("error isFatchToken", this.$store.getters.getIsFatchToken())
            if (!this.$store.getters.getIsFatchToken()) {
              const authorization = `Bearer ${this.$store.getters.getToken()}`;
              const params = {
                // This is where any header, path, or querystring request params go.
                authorization: authorization
              };
              const body = {
                // This is where you define the body of the request
                refreshToken: this.$store.getters.getRefreshToken().replace(/['"]+/g, '')
              };
              const additionalParams = {
              };
              const apigClient = apigClientFactory.newClient();
              apigClient.apiV1IdentityRefreshAccessTokenPost(params, body, additionalParams)
              .then((res: any) => {
                console.log("refreshToken", res.data.refreshToken);
                this.$store.commit('SET_Token', res.data.token);
                this.$store.commit('SET_RefreshToken', res.data.refreshToken);
                this.$store.commit('SET_IsFatchToken', false);
                this.onAccessTokenFetched(res.data.token);
              }).catch((err:any) => {
                console.log(err);
                this.$store.commit('SET_IsFatchToken', true);
                this._expiredSession();
              })
            } else {
              this._expiredSession();
            }
          }
          
          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((access_token:any) => {
              // originalRequest.headers.Authorization = 'Bearer ' + access_token
              let token = 'Bearer ' + access_token;
              let phone = originalRequest.data.destinationNumber;
            
              console.log("original Request", originalRequest);
              resolve(this.getApiSmsSend(phone, token));
            });
          });
          return retryOriginalRequest;
          
        } else if (error.status == 403) {
          this._expiredSession();
        }
      }else if(this.$store.getters.getLoggedIn() === false) {
        this._expiredSession();
      }

      return Promise.reject(error);
    },
    getRefreshTokenNoPolis(error: any){
      const { config } = error
      const originalRequest = config;

      console.log("error isLoggedIn", this.$store.getters.getLoggedIn())
      if(this.$store.getters.getLoggedIn() === true) {
        console.log("error status", error.status)
        if(error.status == 401) {
          console.log('intercept errors 401', this.$store.getters.getRefreshToken())
          if (!this.$store.getters.getRefreshToken()) {
            this._expiredSession();
          } else {
            console.log("error isFatchToken", this.$store.getters.getIsFatchToken())
            if (!this.$store.getters.getIsFatchToken()) {
              const authorization = `Bearer ${this.$store.getters.getToken()}`;
              const params = {
                // This is where any header, path, or querystring request params go.
                authorization: authorization
              };
              const body = {
                // This is where you define the body of the request
                refreshToken: this.$store.getters.getRefreshToken().replace(/['"]+/g, '')
              };
              const additionalParams = {
              };
              const apigClient = apigClientFactory.newClient();
              apigClient.apiV1IdentityRefreshAccessTokenPost(params, body, additionalParams)
              .then((res: any) => {
                console.log("refreshToken", res.data.refreshToken);
                this.$store.commit('SET_Token', res.data.token);
                this.$store.commit('SET_RefreshToken', res.data.refreshToken);
                this.$store.commit('SET_IsFatchToken', false);
                this.onAccessTokenFetched(res.data.token);
              }).catch((err:any) => {
                console.log(err);
                this.$store.commit('SET_IsFatchToken', true);
                this._expiredSession();
              })
            } else {
              this._expiredSession();
            }
          }
          
          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((access_token:any) => {
              // originalRequest.headers.Authorization = 'Bearer ' + access_token
              let token = 'Bearer ' + access_token;
              let phone = originalRequest.data.NoPolis;
            
              console.log("original Request", originalRequest);
              resolve(this.submissionOptionalSend(phone, token));
            });
          });
          return retryOriginalRequest;
          
        } else if (error.status == 403) {
          this._expiredSession();
        }
      }else if(this.$store.getters.getLoggedIn() === false) {
        this._expiredSession();
      }

      return Promise.reject(error);
    }
  },
  computed: {
    urlQuestionnaire(): any {
      return "https://skn.slfi.co/q/" + this.submissionId
    },
    invalidPhone(): any {
      return this.form.phone === '';
    },
    invalidNoPolis(): any {
      return this.form2.noPolis === '';
    }
  },
  mounted() {
    const content = document.getElementById('content');
    if (content != null) {
      content.style.position = 'relative';
      content.style.minHeight = '70vh';
    }
    const footer = document.getElementById('footer');
    if (footer != null) {
      footer.style.bottom = '0';
      footer.style.position = 'relative';
      footer.style.width = '100%';
      footer.style.height = 'auto';
    }
  },
});
